import React from "react";
import PropTypes from "prop-types";
import AnimatedSection from "./AnimatedSection.jsx";
import BlogArticleHome from "./BlogArticleHome.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltCircleRight } from "@fortawesome/free-solid-svg-icons";

export default function BlogSection({ isClient, articles }) {
  const SectionContent = ({ wrapperClass }) => (
    <div className={wrapperClass} id="blog">
      <div>
        <h2 className="text-3xl text-bleuciel text-center mb-5">Blog</h2>
        <p className="mb-5">
          Mes astuces, mes inspirations et solutions concernant le développement
          web et le graphisme.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {Array.isArray(articles) ? (
          articles.map((article) => (
            <BlogArticleHome key={article.id} article={article} />
          ))
        ) : (
          <p className="text-error">Pas d&apos;articles disponibles</p>
        )}
      </div>
      <div>
        <p className="my-5 text-center">
          <a
            href="/blog"
            className="hover:underline"
            aria-label="Blog - autres articles">
            <FontAwesomeIcon icon={faArrowAltCircleRight} className="mr-2" />{" "}
            Autres articles
          </a>
        </p>
      </div>
    </div>
  );
  return isClient ? (
    <AnimatedSection id="blog" className="blog skills section-bg text-center ">
      <div className="mx-10">
        <SectionContent />
      </div>
    </AnimatedSection>
  ) : (
    <div className="blog skills section-bg text-center ">
      <div className="container m-auto">
        <SectionContent />
      </div>
    </div>
  );
}

BlogSection.propTypes = {
  isClient: PropTypes.bool.isRequired,
  articles: PropTypes.arrayOf(PropTypes.object),
};
